import { gql } from "@apollo/client";

export const GET_PROJECT_USER_MAPPING = gql`
  query q1($course_id: Int!, $user_id: Int!) {
    courses_project_user_mappings(
      where: { user_id: { _eq: $user_id }, course_id: { _eq: $course_id } }
    ) {
      id
      payment_attempts
      project_code
      candidate_status
      batch_start_at
      batch_end_at
      last_payment_status
    }
  }
`;

export const GET_FREEZE_WINDOW = gql`
  query q1($course_id: bigint!) {
    courses_course(where: { id: { _eq: $course_id } }) {
      freeze_repay_from
      freeze_repay_to
      iibf_exam_date
    }
  }
`;
